import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateLabelSmartScheduleShift", function updateLabelSmartScheduleShift(title: string) {
    if (shiftEditorViewState().smartScheduleShift) {
        shiftEditorViewState().smartScheduleShift.title = title;
    }
});